require('./mortgageRequestCardInformation.scss');
require('./mortgageRequestCardInformation.override.scss');

// @Vendor
const React = require('react');
const PropTypes = require('prop-types');
const className = require('classnames');
const { isNumber, isEqual, isEmpty } = require('lodash');
const set = require('lodash/object/set');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKInput } = require('commonsComponents/OKInput');
const MortgageRequestFormModal = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestFormModal/mortgageRequestFormModal');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @utilities
const { getFormattedAmount, getFormattedString } = require('utilities/currencyHelper');

// @constants
const { mortgageRequestPreApprovalCommons, idModalsMortgageRequest } = require('constants/mortgageRequestPreApproval');
const { HOLDER_OPTION_ONE, HOLDER_OPTION_TWO } = mortgageRequestPreApprovalCommons;
const { OTHER_LOANS_AND_MORTGAGES, INCOMES_AND_EXPENSES } = idModalsMortgageRequest;
const { EURO_SYMBOL } = require('constants/index');

class MortgageRequestCardInformation extends React.Component {
    constructor(props) {
        super(props);

        this.inputs = {
            triggerInput: {}
        };

        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    handleToggleModal(modalInEvent, options = {}) {
        const {
            onHandleValidateObligatoryFields,
            onHandleChangeModalActive,
            idModal,
            onHandleActionPreviousNextButton,
            discardTemporalChangesInCurrentModal
        } = this.props;

        if (!modalInEvent && options.fromClose) {
            discardTemporalChangesInCurrentModal();
        }
        onHandleValidateObligatoryFields(idModal);
        onHandleChangeModalActive(modalInEvent);
        onHandleActionPreviousNextButton(false);

        if (!isEmpty(this.inputs.triggerInput)) {
            this.inputs.triggerInput.el.blur();
        }
    }

    buildCardHeader() {
        const { title, idModal, immMortgageRequest, isClientWithoutAccounts, responsiveMobileVersion } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const shouldDisableEditButton = (
            selectedHolder === HOLDER_OPTION_ONE &&
            idModal === idModalsMortgageRequest.DATE_OF_BIRTH &&
            !isClientWithoutAccounts
        );

        return (
            <div className="col-md-12 mortgage-request-card-information__card-header">
                <div className="row">
                    <div className="col-xs-10 col-md-9">
                        <span className="mortgage-request-card-information__card-title">
                            {title}
                        </span>
                        <span className="mortgage-request-card-information__card-title-separator"></span>
                    </div>
                    <div className={responsiveMobileVersion ? "col-xs-2 col-md-3 mortgage-request-card-information__card-header-button": "col-xs-2 col-md-3"}  >
                        <OKButton
                            modifier="task"
                            onClick={() => this.handleToggleModal(idModal)}
                            disabled={shouldDisableEditButton}
                        >
                            <i className="icon-editar" />
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    formatIncomeAndMortgageValue(value) {
        const { idModal } = this.props;
        let newValue = value;
        if (idModal === OTHER_LOANS_AND_MORTGAGES || idModal === INCOMES_AND_EXPENSES) {
            if (isNumber(newValue) || (isNumber(newValue) && newValue >= 0)) {
                const formattedAmount = getFormattedAmount({ amount: newValue, decimalsLength: 0 });
                newValue = getFormattedString({ amount: parseInt(formattedAmount.replace(/\D/, '')), currency: EURO_SYMBOL, decimalsLength: 0 });
            }
        }

        return newValue;
    }

    buildFirstHolder() {
        const { firstHolderInfo } = this.props;
        const firstHolderHasInfo = firstHolderInfo && !firstHolderInfo.find(e => (
            e.isEmptyDateOfBirth
        ));
        const shouldRenderInfo = () => {
            const value = firstHolderInfo.some(entry => {
                const value = entry.value || 0;
                return `${value}`.length > 0;
            });
            return value;
        };
        let firstHolderElm;

        if (shouldRenderInfo() && firstHolderHasInfo) {
            firstHolderElm = (
                <div>
                    <div className="col-md-12 mortgage-request-card-information__card-first-holder">
                        <FormattedText
                            className="mortgage-request-card-information__card-holder-title"
                            value="mortgageRequestPreApprovalStepThree-firstOwner"
                        />
                        <span className="mortgage-request-card-information__card-holder-values">
                            {firstHolderInfo && firstHolderInfo.map((element, index) => {
                                const value = element.value !== '' ? (
                                    <span className="mortgage-request-card-information__card-holder-value">
                                        {this.formatIncomeAndMortgageValue(element.value)}
                                    </span>
                                ) : null;
                                const description = element.description ? (
                                    <span className="mortgage-request-card-information__card-holder-description">
                                        {element.description}
                                    </span>
                                ) : null;

                                return (
                                    <div key={'firstHolderInfo-' + index}>
                                        {value}
                                        {description}
                                    </div>
                                );
                            })}
                        </span>
                    </div>
                </div>
            );
        }

        return firstHolderElm;
    }

    buildSecondHolder() {
        const { secondHolderInfo, immMortgageRequest } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const customClass = className('mortgage-request-card-information__card-second-holder', {
            'mortgage-request-card-information__card-second-holder--hidden': selectedHolder === HOLDER_OPTION_ONE
        });

        return (
            <div className="col-md-12">
                <div className={customClass}>
                    <FormattedText
                        className="mortgage-request-card-information__card-holder-title"
                        value="mortgageRequestPreApprovalStepThree-secondOwner"
                    />
                    <span className="mortgage-request-card-information__card-holder-values">
                        {secondHolderInfo && secondHolderInfo.map((element, index) => {
                            return (
                                <div key={'secondHolderInfo-' + index}>
                                    <span className="mortgage-request-card-information__card-holder-value">
                                        {this.formatIncomeAndMortgageValue(element.value)}
                                    </span>
                                    {element.description &&
                                        <span className="mortgage-request-card-information__card-holder-description">
                                            {element.description}
                                        </span>}
                                </div>
                            );
                        })}
                    </span>
                </div>
            </div>
        );
    }

    isHolderEmpty(holder) {
        return holder.every(holder => holder.value === '')
    }

    render() {
        const {
            children,
            immMortgageRequest,
            valid,
            semiComplete,
            errorText,
            idPreviousModal,
            idNextModal,
            idModal,
            isNavigationButtonsAvailable,
            onHandleChangeModalActive,
            onHandleValidateObligatoryFields,
            onHandleActionPreviousNextButton,
            handlerInfoOtherLoansMortgages,
            firstHolderInfo = [],
            secondHolderInfo = [],
            onHandleDependents,
            getDateValidity,
            temporalHolderBirthDates,
            clearTemporalChangesInCurrentModal,
            responsiveMobileVersion
        } = this.props;

        const isFirstHolderEmpty = this.isHolderEmpty(firstHolderInfo);
        const isSecondHolderEmpty = this.isHolderEmpty(secondHolderInfo);
        const showModal = isEqual(immMortgageRequest.get('isModalActive'), idModal);
        const currentModal = immMortgageRequest.getIn(['validModals', idModal], {});
        const semiCompleteSecondHolder = currentModal.getIn(['fields', HOLDER_OPTION_TWO, 'semiComplete'], false);
        const cardHeader = this.buildCardHeader();
        const firstHolderSection = this.buildFirstHolder();
        const secondHolderSection = semiCompleteSecondHolder ? this.buildSecondHolder() : null;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const separatorElm = !!firstHolderSection && !!secondHolderSection && selectedHolder === HOLDER_OPTION_TWO ? (
            <div className="col-md-12">
                <hr className="mortgage-request-card-information__card-info-separator" />
            </div>
        ) : null
        const customClass = className('mortgage-request-card-information__card-container', {
            'mortgage-request-card-information__card-container--large': (
                selectedHolder === HOLDER_OPTION_TWO && semiCompleteSecondHolder && !(isFirstHolderEmpty && isSecondHolderEmpty)
            ),
            'mortgage-request-card-information__card-container--error': !valid
        });
        const errorContainer = !valid ? (
            <div className="col-md-12 mortgage-request-card-information__error-text">
                {errorText}
            </div>
        ) : null
        const holdersContent = semiComplete ? (
            <React.Fragment>
                {firstHolderSection}
                {separatorElm}
                {secondHolderSection}
            </React.Fragment>
        ) : (
            <div className="col-md-12 mortgage-request-card-information__trigger-input">
                <OKInput
                    ref={input => set(this.inputs, "triggerInput", input)}
                    onFocus={() => this.handleToggleModal(idModal)}
                />
            </div>
            );

        return (
            <div className="col-md-4 mortgage-request-card-information">
                <div className="row">
                    <div className="col-md-12">
                        <div className={customClass}>
                            <div className="row">
                                {cardHeader}
                                {holdersContent}
                                <MortgageRequestFormModal
                                    showModal={showModal}
                                    onHandleToggleModal={(_, options) => this.handleToggleModal('', options)}
                                    onHandleChangeModalActive={onHandleChangeModalActive}
                                    onHandleActionPreviousNextButton={onHandleActionPreviousNextButton}
                                    onHandleValidateObligatoryFields={onHandleValidateObligatoryFields}
                                    onHandleDependents={onHandleDependents}
                                    handlerInfoOtherLoansMortgages={handlerInfoOtherLoansMortgages}
                                    immMortgageRequest={immMortgageRequest}
                                    children={children}
                                    nextModal={idNextModal}
                                    previousModal={idPreviousModal}
                                    currentModal={idModal}
                                    getDateValidity={getDateValidity}
                                    temporalHolderBirthDates={temporalHolderBirthDates}
                                    clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                                    isNavigationButtonsAvailable={isNavigationButtonsAvailable}
                                    responsiveMobileVersion={responsiveMobileVersion}
                                />
                            </div>
                        </div>
                    </div>
                    {errorContainer}
                </div>
            </div>
        );
    }
}

MortgageRequestCardInformation.propTypes = {
    children: PropTypes.element.isRequired,
    clearTemporalChangesInCurrentModal: PropTypes.func.isRequired,
    discardTemporalChangesInCurrentModal: PropTypes.func.isRequired,
    errorText: PropTypes.string,
    firstHolderInfo: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
        description: PropTypes.string
    })).isRequired,
    getDateValidity: PropTypes.func,
    handlerInfoOtherLoansMortgages: PropTypes.func,
    idModal: PropTypes.string.isRequired,
    idNextModal: PropTypes.string,
    idPreviousModal: PropTypes.string,
    immMortgageRequest: PropTypes.object.isRequired,
    isClientWithoutAccounts: PropTypes.bool,
    isNavigationButtonsAvailable: PropTypes.bool,
    onHandleValidateObligatoryFields: PropTypes.func.isRequired,
    onHandleChangeModalActive: PropTypes.func.isRequired,
    onHandleActionPreviousNextButton: PropTypes.func.isRequired,
    onHandleDependents: PropTypes.func,
    secondHolderInfo: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        description: PropTypes.string
    })).isRequired,
    semiComplete: PropTypes.bool.isRequired,
    temporalHolderBirthDates: PropTypes.object,
    title: PropTypes.string.isRequired,
    valid: PropTypes.bool,
}

MortgageRequestCardInformation.defaultProps = {
    valid: true,
    isNavigationButtonsAvailable: true,
    handlerInfoOtherLoansMortgages: () => { }
}

module.exports = MortgageRequestCardInformation;
